// ChartToggle.js
import React from 'react';

const ChartToggle = ({ activeView, onToggle }) => {
  return (
    <div className="chart-toggle">
      <button 
        className={`toggle-button ${activeView === 'value' ? 'active' : ''}`}
        onClick={() => onToggle('value')}
      >
        Gesamtwert
      </button>
      <button 
        className={`toggle-button ${activeView === 'growth' ? 'active' : ''}`}
        onClick={() => onToggle('growth')}
      >
        Wachstum
      </button>
    </div>
  );
};

export default ChartToggle;